import { createSlice } from '@reduxjs/toolkit'
import {getFactoryCategories} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  categories: [], 
  loading: "idle",
  error: null }

const factoryCategoriesSlice = createSlice({
  name: 'factoryCategories',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryCategories.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryCategories.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.categories = action.payload
      
    },
    [getFactoryCategories.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearProvinceError} = factoryCategoriesSlice.actions;
export default factoryCategoriesSlice.reducer
